// Mock data for Adhira & Appa Toys - Homepage
// NOTE: All data here is mocked for frontend-only demo. Replace with API calls during backend integration.

export const LOGO_URL = "https://customer-assets-39nsmqrw.emergentagent.net/job_63357c08-e046-4224-b5c1-355c0d6a5775/artifacts/eb38xfcx_Asset%2014%403x.png";

export const navItems = [
  {
    label: "Shop by Age",
    path: "/shop-by-age",
    activeColor: "#35C3C1",
    dropdown: [
      { label: "0 - 1 Years", icon: "Baby" },
      { label: "1 - 3 Years", icon: "ToyBrick" },
      { label: "3 - 6 Years", icon: "Puzzle" },
      { label: "6 - 10 Years", icon: "Bot" },
      { label: "10+ Years", icon: "Gamepad2" },
    ],
  },
  {
    label: "Toys & Games",
    path: "/toys-games",
    activeColor: "#35C3C1",
    dropdown: [
      { label: "Soft Toys", icon: "Dog" },
      { label: "Building Blocks", icon: "Blocks" },
      { label: "Board Games", icon: "Dices" },
      { label: "Puzzles", icon: "Puzzle" },
      { label: "Remote Control", icon: "Car" },
      { label: "Action Figures", icon: "PersonStanding" },
      { label: "Dolls & Playsets", icon: "Baby" },
    ],
  },
  {
    label: "Learning & Education",
    path: "/learning-education",
    activeColor: "#35C3C1",
    dropdown: [
      { label: "STEM Toys", icon: "Bot" },
      { label: "Art & Craft", icon: "Palette" },
      { label: "Musical Toys", icon: "Music" },
      { label: "Books & Flashcards", icon: "BookOpen" },
      { label: "Science Kits", icon: "FlaskConical" },
    ],
  },
  {
    label: "Gifts",
    path: "/gifts",
    activeColor: "#35C3C1",
    dropdown: [
      { label: "Birthday Gifts", icon: "Cake" },
      { label: "Return Gifts", icon: "ShoppingBag" },
      { label: "Gift Cards", icon: "CreditCard" },
      { label: "Festive Specials", icon: "Sparkles" },
    ],
  },
  {
    label: "All Categories",
    path: "/categories",
    activeColor: "#7C4DC4",
    dropdown: null,
  },
  {
    label: "Our Franchise",
    path: "/franchise",
    activeColor: "#F79433",
    dropdown: null,
  },
];

export const EBG_LOGO_URL = "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/djm3z5gx_EBG%20Logo.png";

export const heroSlides = [
  {
    id: "play",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/gz75ggih_Home%20page%2001.webp",
    imagePosition: "72% center",
    badge: null,
    titleLines: [
      { t: "PLAY.", c: "#1B1F5C" },
      { t: "LEARN.", c: "#F79433" },
      { t: "GROW.", c: "#35C3C1" },
      { t: "TOGETHER!", c: "#1B1F5C" },
    ],
    desc: "Handpicked toys that inspire imagination, build skills and create joyful memories.",
    primaryCta: { label: "ENQUIRE NOW", to: "/toys-games", enquiry: true },
    secondaryCta: { label: "EXPLORE COLLECTION", to: "/toys-games" },
  },
  {
    id: "franchise",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/z0gpveur_imag02.png",
    imagePosition: "75% center",
    badge: "FRANCHISE OPPORTUNITY",
    titleLines: [
      { t: "BUILD A", c: "#1B1F5C" },
      { t: "BUSINESS", c: "#F79433" },
      { t: "FULL OF JOY!", c: "#35C3C1" },
    ],
    desc: "Partner with Adhira & Appa Toys and bring smiles to your city. Now inviting founding franchise partners across India.",
    primaryCta: { label: "BECOME A PARTNER", to: "/franchise" },
    secondaryCta: { label: "EXPLORE MODELS", to: "/franchise" },
  },
];

export const heroData = {
  image: "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/ml8ot1eu_home%20hero.png",
  trustedCount: "Growing",
  avatars: [
    "https://i.pravatar.cc/60?img=32",
    "https://i.pravatar.cc/60?img=47",
    "https://i.pravatar.cc/60?img=12",
    "https://i.pravatar.cc/60?img=5",
    "https://i.pravatar.cc/60?img=68",
    "https://i.pravatar.cc/60?img=25",
  ],
};

export const trustBadges = [
  { icon: "ShieldCheck", line1: "100% Safe", line2: "& Non-Toxic" },
  { icon: "BadgeCheck", line1: "Premium", line2: "Quality Toys" },
  { icon: "Heart", line1: "Curated with", line2: "Love" },
  { icon: "Gift", line1: "Gifts for", line2: "Every Age" },
  { icon: "Headset", line1: "Quick Enquiry", line2: "Support" },
];

export const brandStory = {
  videoPoster: null,
  videoUrl: "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/r17c4wl4_brand%20video.mp4",
  caption: "Building happy childhoods, one toy at a time.",
};

export const ageCategories = [
  { label: "0 - 1 Years", image: "/images/ages/age-0-1.png" },
  { label: "1 - 3 Years", image: "/images/ages/age-1-3.png" },
  { label: "3 - 6 Years", image: "/images/ages/age-3-6.png" },
  { label: "6 - 10 Years", image: "/images/ages/age-6-10.png" },
  { label: "10+ Years", image: "/images/ages/age-10plus.png" },
];

export const promoBanners = [
  {
    title: "Learning\nMade Fun!",
    desc: "Explore educational toys that make learning exciting.",
    cta: "EXPLORE LEARNING",
    to: "/learning-education",
    bg: "#FCD44E",
    btnBg: "#1B1F5C",
    btnColor: "#FCD44E",
    textColor: "#1B1F5C",
    image: "https://images.pexels.com/photos/6693318/pexels-photo-6693318.jpeg?auto=compress&w=600",
  },
  {
    title: "Games for\nEvery Play!",
    desc: "Board games, puzzles & more for endless fun.",
    cta: "EXPLORE GAMES",
    to: "/toys-games",
    bg: "#35C3C1",
    btnBg: "#1B1F5C",
    btnColor: "#FFFFFF",
    textColor: "#FFFFFF",
    image: "https://images.unsplash.com/photo-1539477192933-1a7dde04aa77?w=600&q=80",
  },
  {
    title: "The Perfect\nGift for Every\nOccasion!",
    desc: "Toys that bring smiles on birthdays & beyond.",
    cta: "EXPLORE GIFTS",
    to: "/gifts",
    bg: "#FBD9E6",
    btnBg: "#1B1F5C",
    btnColor: "#FFFFFF",
    textColor: "#1B1F5C",
    image: "https://images.pexels.com/photos/6087540/pexels-photo-6087540.jpeg?auto=compress&w=600",
  },
];

export const topPicks = [
  {
    id: 1,
    name: "Hamleys Soft Teddy Bear – Beige (60 cm)",
    price: 899,
    mrp: 1299,
    off: "31% OFF",
    rating: 4.5,
    reviews: 256,
    image: "/images/toppicks/toppick1.png",
  },
  {
    id: 2,
    name: "LEGO Classic Creative Brick Box (484 Pieces)",
    price: 2799,
    mrp: 3999,
    off: "30% OFF",
    rating: 4.8,
    reviews: 512,
    image: "/images/toppicks/toppick2.png",
  },
  {
    id: 3,
    name: "Remote Control Stunt Car – 360° Flips",
    price: 1499,
    mrp: 2199,
    off: "32% OFF",
    rating: 4.3,
    reviews: 189,
    image: "/images/toppicks/toppick3.png",
  },
  {
    id: 4,
    name: "FunBlast Basketball Hoop for Kids",
    price: 799,
    mrp: 1199,
    off: "33% OFF",
    rating: 4.6,
    reviews: 101,
    image: "/images/toppicks/toppick4.png",
  },
  {
    id: 5,
    name: "Barbie Dreamhouse Playset",
    price: 6999,
    mrp: 9999,
    off: "30% OFF",
    rating: 4.7,
    reviews: 215,
    image: "/images/toppicks/toppick5.png",
  },
];

export const newArrivals = [
  {
    id: "na1",
    name: "Catan Board Game (Family Edition)",
    price: 2249,
    mrp: 2999,
    off: "25% OFF",
    rating: 4.5,
    reviews: 164,
    image: "https://images.pexels.com/photos/8111328/pexels-photo-8111328.jpeg?auto=compress&w=500",
  },
  {
    id: "na2",
    name: "Interactive Puppy Soft Toy",
    price: 1899,
    mrp: 2499,
    off: "24% OFF",
    rating: 4.6,
    reviews: 177,
    image: "https://images.unsplash.com/photo-1618397360709-9dd900837411?w=500&q=80",
  },
  {
    id: "na3",
    name: "National Geographic Science Magic Kit",
    price: 1999,
    mrp: 2899,
    off: "31% OFF",
    rating: 4.4,
    reviews: 119,
    image: "https://images.pexels.com/photos/2280571/pexels-photo-2280571.jpeg?auto=compress&w=500",
  },
  {
    id: "na4",
    name: "Hot Wheels Track Builder Unlimited",
    price: 2199,
    mrp: 2999,
    off: "27% OFF",
    rating: 4.5,
    reviews: 142,
    image: "https://images.unsplash.com/photo-1778589581022-49b20aeb144a?w=500&q=80",
  },
  {
    id: "na5",
    name: "Orboot Earth Interactive Globe",
    price: 3299,
    mrp: 4499,
    off: "27% OFF",
    rating: 4.4,
    reviews: 143,
    image: "https://images.pexels.com/photos/8828358/pexels-photo-8828358.jpeg?auto=compress&w=500",
  },
  {
    id: "na6",
    name: "Art & Craft Mega Gift Set",
    price: 1199,
    mrp: 1499,
    off: "20% OFF",
    rating: 4.5,
    reviews: 105,
    image: "https://images.unsplash.com/photo-1779315399754-4aee2ca63b18?w=500&q=80",
  },
];

export const brands = [
  { name: "LEGO", style: "lego" },
  { name: "Barbie", style: "script" },
  { name: "Fisher-Price", style: "serif" },
  { name: "NERF", style: "bold-italic" },
  { name: "Hot Wheels", style: "flame" },
  { name: "Hasbro", style: "rounded" },
  { name: "playmobil", style: "lower" },
  { name: "chicco", style: "chicco" },
];

export const whyUs = [
  { icon: "Baby", title: "Safe & Non-Toxic", desc: "Only child-safe materials" },
  { icon: "ShieldCheck", title: "Expertly Curated", desc: "Handpicked toys by child experts" },
  { icon: "BadgePercent", title: "Value for Money", desc: "Best quality at great prices" },
  { icon: "Truck", title: "Wide Toy Range", desc: "For every age, 0 to 14+" },
  { icon: "RotateCcw", title: "Quick Enquiry Support", desc: "WhatsApp & call assistance" },
];

export const newsletterPerks = [
  { icon: "Truck", title: "100% Safe Toys", desc: "Child-safe & non-toxic" },
  { icon: "Timer", title: "Trusted Brands", desc: "Premium global brands" },
  { icon: "PackageOpen", title: "Gifts for Every Age", desc: "0 to 14+ years" },
  { icon: "Headphones", title: "Quick Enquiry Support", desc: "We're here to help" },
];

export const instagramPosts = [
  { id: "ig1", image: "https://images.unsplash.com/photo-1581841899040-8b5e38bae033?w=500&q=80", likes: 1240, comments: 48 },
  { id: "ig2", image: "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/11duxknn_02.png", likes: 986, comments: 32 },
  { id: "ig3", image: "https://images.unsplash.com/photo-1633469924738-52101af51d87?w=500&q=80", likes: 1523, comments: 67 },
  { id: "ig4", image: "https://images.unsplash.com/photo-1603185030522-05d4497bb180?w=500&q=80", likes: 875, comments: 29 },
  { id: "ig5", image: "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/j82g5hl5_06.png", likes: 1102, comments: 41 },
  { id: "ig6", image: "https://images.pexels.com/photos/6087540/pexels-photo-6087540.jpeg?auto=compress&w=500", likes: 1348, comments: 55 },
];

export const footerLinks = {
  shop: ["Shop by Age", "Toys & Games", "Learning & Education", "Gifts", "All Collections"],
  help: ["Store Locator", "FAQs", "Contact Us", "Help Center"],
  about: ["Our Story", "Our Franchise", "Blog"],
};
